import * as React from 'react';
import type { SVGProps } from 'react';

const SuccessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width={24}
    height={24}
    {...props}
  >
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M1.333 8a6.667 6.667 0 1 0 13.334 0A6.667 6.667 0 0 0 1.333 8m12.122 0a5.455 5.455 0 1 1-10.91 0 5.455 5.455 0 0 1 10.91 0"
        clipRule="evenodd"
      />
      <path d="m6.724 8.831 3.123-3.498.82.918-3.943 4.416-2.057-2.304.82-.918z" />
    </g>
  </svg>
);
export { SuccessIcon as ReactComponent };
